var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bunner"},[_c('a',{attrs:{"href":"https://bit.ly/2V2uG6J"}},[_c('img',{attrs:{"src":"/img/onlinefesta.png"}})])])}]

export { render, staticRenderFns }